module.exports = __webpack_public_path__ + "images/emoji/ab.3e696eaa00c110118a3d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ab.png
// module id = IyYY
// module chunks = 1